import Vue from "vue"

var VueScrollTo = require('vue-scrollto')

Vue.use(VueScrollTo)

// You can also pass in the default options


// WEBPACK FOOTER //
// ./src/untils/scroll-to.js